import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { GithubPersonalNotificationsProps } from "./types";

export const details = {
  name: "GithubPersonalNotifications",
  description: "Displays a list of your GitHub personal notifications",
  tags: ["Development"],
  category: "Github",
  grid: { default: [3, 3], large: [4, 4] },
  gridNames: { default: "Medium", large: "Large" },
  integrationsUsed: ["github_personal"],
  context: lazy(() => import("./Context").then(m => ({ default: m.Context }))),
  defaultProps: {},
} as ElementDetails<GithubPersonalNotificationsProps>;
